###
  SmartTV Video creative widget
###

class INTENT.widgets.SmartTvCreative

  @ATTR_NAME: "data-widget-smart-tv-creative"
  uploaders: {}
  video_formats:
    available: []
    playable: ['mp4', 'webm']

  constructor: (@el) ->
    @s = @.constructor

    @max_file_size = +@el.attr("#{@s.ATTR_NAME}-max-file-size"); # bytes
    @video_formats.available = @el.attr("#{@s.ATTR_NAME}-available-video-formats").split(';')
    @file_group_container = @el.find "[#{@s.ATTR_NAME}-file-group-container]"
    @file_group_template = @el.find("[#{@s.ATTR_NAME}-file-group-template]").html()
    @load_button_template = @el.find("[#{@s.ATTR_NAME}-load-button-template]").html()
    @loaded_link_template = @el.find("[#{@s.ATTR_NAME}-loaded-link-template]").html()
    @loaded_preview_template = @el.find("[#{@s.ATTR_NAME}-loaded-preview-template]").html()
    @btnSubmit = $ '[name="update"].submit-button'
    @btnSubmitJson = $ '[name="save_raw_edit"].submit-button'

    init_files = @el.data 'widget-smart-tv-creative-init-files'
    if init_files
      for file in init_files
        @add_file_group file
    else
      do @add_file_group

    @el.on 'click', "[#{@s.ATTR_NAME}-file-group-remove]", (e) =>
      e.preventDefault()
      self = $(e.currentTarget)
      index = self.attr "#{@s.ATTR_NAME}-file-group-remove"
      group = @el.find "[#{@s.ATTR_NAME}-file-group='#{index}']"
      if group.length
        @cancel_file_upload index
        do @update_form_buttons
        self.tooltip('destroy')
        group.find('select').destroySelect2()
        #удалем файл. Посылаем событие, что файл удалили
        if document.getElementById('files_'+index+'_url') != null
          eventRemoveFile = new CustomEvent("event_remove_video_file", {
            detail: {newIndex: index, deletedUrl: document.getElementById('files_'+index+'_url').value}
          })
          document.dispatchEvent(eventRemoveFile);
        ####
        group.fadeOut 'fast', () ->
          do @.remove

    @el.on 'click', "[#{@s.ATTR_NAME}-file-group-add]", (e) =>
      e.preventDefault()
      self = $(e.currentTarget)
      if self.attr('disabled')
        return false
      do @add_file_group

    @el.on 'submit', "[#{@s.ATTR_NAME}-form]", (e) =>
      errorTextValidateCreativeForm = INTENT.utils.CreativesValidation.validateForm()
      if errorTextValidateCreativeForm != ''
        INTENT.utils.Forms.disable_submit_buttons_loader()
        return
      self = $(e.currentTarget)
      data = self.serializeObject()
      files = data.files or []
      valid_files_count = 0
      for file in files
        if not file
          continue
        extension = file.url.split('.').pop().toLowerCase()
        if extension in @video_formats.available
          valid_files_count++

      if valid_files_count <= 0
        e.preventDefault()
        @btnSubmit.each((id, e) ->
          self = $(e)
          if (self.hasClass('disabled'))
            self.text(__('btn.save')).removeClass('disabled').prop 'disabled', no
        )
        @btnSubmitJson.each((id, e) ->
          self = $(e)
          if (self.hasClass('disabled'))
            self.text(__('btn.save.json')).removeClass('disabled').prop 'disabled', no
        )
        INTENT.utils.Notify.error __('creative.video.validator.error.required-formats')

  add_file_group: (data = false) ->
    index = 0
    while @el.find("[#{@s.ATTR_NAME}-file-group='#{index}']").length > 0
      index++

    new_group = jQuery @get_file_group_template(index, data)
    last_group = @file_group_container.find("[#{@s.ATTR_NAME}-file-group]:last")
    if last_group.length
      last_group.after new_group
    else
      @file_group_container.prepend new_group

    if not data
      @init_file_uploader index
    @init_mask new_group.find("[#{@s.ATTR_NAME}-size]")
    getintent.utils.Autoinit.init(INTENT.widgets.Tooltip)

  get_file_group_template: (index, data = false) =>
    if index == undefined
      return false

    template = @file_group_template
    template = @render_template template, {index: index}

    if data
      template = @render_template template, data

    if data.url
      upload_wrapper_body = @get_file_preview_template index, data
    else
      upload_wrapper_body = @get_file_load_button_template index

    template = template.replace /\#\{upload_wrapper_body\}/g, upload_wrapper_body
    return template

  get_file_load_button_template: (index) =>
    template = @load_button_template
    template = @render_template template, {index: index}

  get_file_preview_template: (index, data) =>
    if index == undefined or not data
      return false

    extension = data.url.split('.').pop().toLowerCase() if data.url

    template = @loaded_link_template
    if extension in @video_formats.playable
      template += @loaded_preview_template

    template = @render_template template, data

  render_template: (template, data = {}) =>
    if not template
      return false

    name = data.url.split('/').pop() if data.url
    template = template.replace /\#\{name\}/g, name if name?
    template = template.replace /\#\{index\}/g, data.index if data.index?
    template = template.replace /\#\{size\}/g, data.size if data.size?
    template = template.replace /\#\{file_size\}/g, data.file_size if data.file_size?
    template = template.replace /\#\{url\}/g, data.url if data.url?
    if !data.length?
      template = template.replace /\(\#\{length\}.*?\)/g, ''
    else
      template = template.replace /\#\{length\}/g, data.length if data.length?
    return template

  render_on_complete: (index, response) =>
    if index == undefined
      return false

    $("[#{@s.ATTR_NAME}-upload-progress-loading='#{index}']").css('display', 'none')

    if response and response.url
      group = jQuery "[#{@s.ATTR_NAME}-file-group='#{index}']"
      group.find("#files_#{index}_size").val response.size if response.size?
      group.find("#files_#{index}_file_size").val response.file_size if response.file_size?
      group.find("#files_#{index}_url").val response.url if response.url?
      group.find("#files_#{index}_length").val response.length if response.length?

      if not @el.find("#video_name").val()
        @el.find("#video_name").val response.basename
      if not @el.find("#video_length").val()
        @el.find("#video_length").val response.length

      upload_wrapper_body = jQuery @get_file_preview_template index, response
      $("[#{@s.ATTR_NAME}-upload-wrapper='#{index}']").html upload_wrapper_body

  render_on_error: (index, response) =>
    if not index?
      return

    if response?
      INTENT.utils.Notify.error(response.error_text, {fadeOut: {enabled: true, delay: 10000}});

    $("[data-widget-smart-tv-creative-upload-progress-loading='#{index}']").css('display', 'none')


  init_mask: (element) =>
    $(element).mask('0ZZZZZZZZZx0ZZZZZZZZZ', {
      translation: {
        'Z': {
          pattern: /[0-9]/,
          optional: true
        }
      }
    });

  init_file_uploader: (index) =>
    element = document.querySelector("[#{@s.ATTR_NAME}-upload-button='#{index}']")
    if element == undefined
      return false

    accept_extensions = []
    for extension in @video_formats.available
      accept_extensions.push('.' + extension)
    accept_extensions = accept_extensions.join(',')

    @uploaders[index] = new qq.FileUploaderBasic({
      button: element,
      action: '/campaigns/upload_video/smart',
      debug: true,
      inputName: 'video',
      encoding: 'multipart',
      multiple: false,
      sizeLimit: @max_file_size,
      acceptFiles: accept_extensions,
      onSubmit: @on_upload_submit,
      onUpload: @on_upload,
      onProgress: @on_upload_progress,
      onComplete: @on_upload_complete,
      onError: @on_upload_error,
      params: {
        index: index,
        helpers: {
          cancel_file_upload: @cancel_file_upload,
          get_file_preview_template: @get_file_preview_template,
          render_on_complete: @render_on_complete,
          render_on_error: @render_on_error,
          update_form_buttons: @update_form_buttons
        }
      },
      messages: {
        sizeError: __('creative.video.uploader.error.file-size'),
      },
      showMessage: (message) ->
        if typeof message == 'string'
          INTENT.utils.Notify.error message
    })

  cancel_file_upload: (index) =>
    if index != undefined and @uploaders[index]
      @uploaders[index]._handler.cancelAll()

  update_form_buttons: () =>
    in_progress = false
    for key, uploader of @uploaders
      if uploader.getInProgress() > 0
        in_progress = true
        break

    if in_progress
      INTENT.utils.Forms.disable_submit_buttons()
    else
      INTENT.utils.Forms.enable_submit_buttons()

  on_upload_submit: ->
    index = @.params.index
    @.params.helpers.cancel_file_upload index
    do @.params.helpers.update_form_buttons

    proggressLoading = $("[data-widget-smart-tv-creative-upload-progress-loading='#{index}']")
    proggressLoading.css('display', 'block')
    proggressLoading.find('.upload-loading-text').html(__('ffmpeg.file.uploading'))

    $("[data-widget-smart-tv-creative-upload-button='#{index}']").addClass('hide_upload_button')

  on_upload: (id, fileName) ->
    #console.log 'on_upload: id, fileName', id, fileName

  on_upload_progress: (id, fileName, loaded, total) ->
    percent = 100
    if loaded < total
      percent = Math.round(loaded / total * 100)

    index = @.params.index
    if (percent >= 100)
      progress_bar = $("[data-widget-smart-tv-creative-upload-progress-loading='#{index}']")
      progress_bar.find('.upload-loading-text').html(__('ffmpeg.file.handling'))

  on_upload_complete: (id, fileName, responseJSON) ->
    index = $(@.button).attr("data-widget-smart-tv-creative-upload-button")
    $("[data-widget-smart-tv-creative-upload-button='#{index}']").removeClass('hide_upload_button')

    if responseJSON.error_text?
      @.params.helpers.render_on_error index, responseJSON
      return

    @.params.helpers.render_on_complete index, responseJSON

    # когда добавили новый файл в видео креатив, нужно послать событие. Оно отслеживается в файле ord_creatives.js
    eventAddFile = new CustomEvent("event_add_video_file", {
      detail: {newIndex: index}
    });
    document.dispatchEvent(eventAddFile)
    ####
    do @.params.helpers.update_form_buttons

  on_upload_error: (id, name, reason, xhr) ->
    console.log 'on_upload_error: id, name, reason, xhr', id, name, reason, xhr
    return false
